import React from "react";
import { useSelector } from "react-redux";

// Constants & Config
import {
  ROOT_CONSTANT
} from '../../../constants'
import * as CONFIG from '../../../config'

// Styles
import "./Logo.css";

const Logo = ({
  onClick = () => {},
  selectedkeys, 
  pKey
}) => {

    const user = useSelector(state => state.containers.v3.user)

  return (
    <div 
      aria-hidden="true" 
      className="sidebar-logo-container" 
      key={pKey}
      onClick={onClick}
      style={{
        marginTop: "5px",
        background: selectedkeys[0] === "/" ? "rgba(0, 0, 0, 0.25)" : ""
      }}
    >
      <img
        src={user.uid === 'u#1748229154788-NeVismwKLeHr' ? ROOT_CONSTANT.THEME.LOGO_ALT : ROOT_CONSTANT.THEME.LOGO}
        alt={CONFIG.APP_INFO.PUBLICATION_COMPANY}
        className="sidebar-logo"
      />
    </div>
  );
};

export default Logo;
